




























































































































































import Vue from 'vue'
import Component from "vue-class-component"
import { customer } from '@/store'
import { Prop } from "vue-property-decorator"
import ProductsSetPopover from "@/components/products/ProductsSetPopover.vue"
import { getFullImageUrl } from '@/utils/functions'
import { 
  createOrder, getDeliveryCities, getDeliveryStreets, 
  getDeliveryWarehouses, getUkrposhtaDeliveryCities, 
  getUkrposhtaDeliveryWarehouses, getRozetkaDeliveryCities,
  getRozetkaDeliveryWarehouses, uploadImage
} from '@/utils/customerApi'
import Order, { emptyOrder } from '@/models/order'
import City, { emptyCity } from '@/models/city'
import Street, { emptyStreet } from '@/models/street'
import Warehouse, { emptyWarehouse } from '@/models/warehouse'
import { emptyImage } from '@/models/productImage'
import { debounce } from 'lodash';
import OrderProduct from '@/models/orderProduct'
import OrderProductsTable from '@/components/orders/OrderProductsTable.vue'
import PaymentType from '@/models/paymentType'
import { deliveryServicesOptions } from '@/utils/constants'
import { shopPath } from '@/utils/shop'
import { track } from '@/utils/track'

@Component({
  components: {
    ProductsSetPopover,
    OrderProductsTable
  }
})
export default class OrderForm extends Vue {
  @Prop() publicUrl!: string
  loading = true
  order: Order = emptyOrder()
  
  getFullImageUrl = getFullImageUrl
  image: File | null = null
  customer = customer

  submitting = false
  valid = false
  attemptedToSumbit = false

  cities: Array<City> = []
  streets: Array<Street> = []
  warehouses: Array<Warehouse> = []
  warehousesLoading = false
  debounceSearchCity: any
  debounceSearchStreet: any

  deliveryServicesOptions = deliveryServicesOptions

  deliveryServiceChanged() {
    // @ts-ignore
    this.order.cityDict = null
    // Rozetka Delivery возит только отделение-отделение
    if (this.order.deliveryService == 'rozetka_delivery') {
      this.order.homeDelivery = false
    }
    this.warehouses = []
    this.cities = []
    this.clearWarehouse()
    this.setDefaultPaymentType()
  }

  async uploadImage() {
    if (this.image) {
      var filename = await uploadImage(this.image)
      if (filename) {
        var image = emptyImage()
        image.filename = filename
        this.order.image = image
        this.$forceUpdate()
      }
    }
  }

  get retailerPage() {
    return customer.retailerPage
  }

  get filteredPaymentTypes() {
    let _paymentTypes: Array<PaymentType> = []
    if (this.retailerPage) {
      this.retailerPage.paymentTypes.forEach((paymentType: PaymentType) => {
        if (this.paymentTypeAllowed(paymentType)) {
          _paymentTypes.push(paymentType)
        }
      });
    }
    return _paymentTypes
  }

  // У каждого способа оплаты свой набор служб доставки
  paymentTypeAllowed(paymentType: PaymentType) {
    if (this.order.deliveryService == 'nova_poshta') {
      return paymentType.novaPoshta
    } else if (this.order.deliveryService == 'ukr_poshta') {
      return paymentType.ukrPoshta
    } else if (this.order.deliveryService == 'rozetka_delivery') {
      return paymentType.rozetkaDelivery
    }
    return false
  }

  setPaymentType(paymentType: PaymentType) {
    this.order.paymentType = paymentType
  }

  get total() {
    var _total = 0
    this.customer.products.forEach((product: OrderProduct) => {
      if (product.price)
        _total += product.price * product.amount
    });
    return _total
  }

  orderProductChanged() {
    customer.setOrder(customer.order)
  }

  removeProduct(index: number) {
    customer.products.splice(index, 1)
    customer.setProducts(customer.products)
    this.$forceUpdate()
  }

  created() {
    this.debounceSearchCity = debounce(this.searchCity, 500)
    this.debounceSearchStreet = debounce(this.searchStreet, 500)
  }

  validateField(field: string, override?: boolean) {
    if (!this.attemptedToSumbit && !override) {
      return true
    }
    var valid = false
    if (field == 'name') {
      valid = this.order.name ? true : false
    } else if (field == 'phone') {
      valid = /^(\+380[0-9]{9}|380[0-9]{9}|0[0-9]{9})$/.test(this.order.phone)
    } else if (field == 'city') {
      valid = true
      if (!this.order.city)
        valid = false
    } else if (field == 'warehouse') {
      if (this.order.homeDelivery) {
        valid = true
      } else if (this.order.deliveryService == 'rozetka_delivery') {
        // у отделений Rozetka Delivery нет номера, только адрес
        valid = this.order.warehouse.warehouseRef ? true : false
      } else {
        valid = this.order.warehouse.number ? true : false
      }
    } else if (field == 'street') {
      if (!this.order.homeDelivery) {
        valid = true
      } else {
        valid = this.order.street ? true : false
      }
    } else if (field == 'houseNumber') {
      if (!this.order.homeDelivery) {
        valid = true
      } else {
        valid = this.order.houseNumber ? true : false
      }
    } else if (field == 'image') {
      if (this.order && this.order.paymentType && this.order.paymentType.askImage
          && this.order.paymentType.requireImage && !this.order.paymentType.wayforpay) {
        if (this.order.image) {
          valid = true
        }
      } else {
        valid = true
      }
    }
    console.log(field, valid)
    return valid
  }

  validate() {
    var validationResults = []
    validationResults.push(this.validateField('name'))
    validationResults.push(this.validateField('phone'))
    validationResults.push(this.validateField('image'))
    if (this.order.deliveryService == 'nova_poshta') {
      validationResults.push(this.validateField('city'))
      validationResults.push(this.validateField('warehouse'))
      validationResults.push(this.validateField('street'))
      validationResults.push(this.validateField('houseNumber'))
    } else if (this.order.deliveryService == 'ukr_poshta'
               || this.order.deliveryService == 'rozetka_delivery') {
      validationResults.push(this.validateField('city'))
      validationResults.push(this.validateField('warehouse'))
    }
    this.valid = validationResults.every((element) => element)
    console.log("validationResults", validationResults)
    console.log("valid", this.valid)
  }

  // Список служб считает бэкенд, витрина только показывает
  get deliveryServices(): Array<string> {
    return (this.retailerPage && this.retailerPage.deliveryServices) || []
  }

  get filteredDeliveryServicesOptions() {
    return this.deliveryServicesOptions.filter(option => this.deliveryServices.includes(option.value))
  }

  get warehouseLabel() {
    if (this.order.deliveryService == 'rozetka_delivery') {
      return this.$t('Отделение')
    }
    if (this.order.homeDelivery && this.order.deliveryService == 'ukr_poshta') {
      return this.$t('Отделение почты (ближайшее к адресу)')
    } else {
      return this.$t('Отделение почты')
    }
  }

  async setCity(city: City) {
    var cityDict = emptyCity()

    cityDict.titleRu = city.titleRu
    cityDict.titleUa = city.titleUa
    this.order.cityDict = cityDict
    this.order.city = city.titleUa
    this.order.cityRef = city.ref
    this.clearWarehouse()
    await this.getWarehouses()
  }

  async setStreet(street: Street) {
    var streetDict = emptyStreet()

    streetDict.titleRu = street.titleRu
    streetDict.titleUa = street.titleUa
    this.order.streetDict = streetDict

    this.order.street = street.titleRu
    this.order.streetRef = street.ref
  }

  async searchStreet(value: string) {
    this.streets = await getDeliveryStreets(this.order.city, this.order.cityRef, value)
  }

  async openWarehouses() {
    if (this.warehouses.length == 0) {
      await this.getWarehouses()
    }
  }

  async getWarehouses() {
    if(this.order.city) {
      this.warehousesLoading = true
      if (this.order.deliveryService == 'nova_poshta') {
        this.warehouses = await getDeliveryWarehouses(this.order.city)
      } else if (this.order.deliveryService == 'rozetka_delivery') {
        this.warehouses = await getRozetkaDeliveryWarehouses(this.order.cityRef)
      } else {
        this.warehouses = await getUkrposhtaDeliveryWarehouses(this.order.cityRef)
      }
      this.warehousesLoading = false
    }
  }

  async searchCity(value: string) {
    if (!value) {
      return
    }
    if (this.order.deliveryService == 'nova_poshta') {
      this.cities = await getDeliveryCities(value, this.order.homeDelivery)
    } else if (this.order.deliveryService == 'rozetka_delivery') {
      this.cities = await getRozetkaDeliveryCities(value)
    } else {
      this.cities = await getUkrposhtaDeliveryCities(value)
    }
  }

  clearWarehouse() {
    this.order.warehouse = emptyWarehouse()
    this.order.warehouseNumber = ""
    this.order.warehouseTitleRu = ""
    this.order.warehouseTitleUa = ""
    this.order.warehouseRef = ""
    this.order.warehouseCategory = ""
  }

  setWarehouse(warehouse: Warehouse) {
    this.order.warehouse = warehouse
    this.order.warehouseNumber = warehouse.number
    this.order.warehouseTitleRu = warehouse.titleRu
    this.order.warehouseTitleUa = warehouse.titleUa
    this.order.warehouseRef = warehouse.warehouseRef
    this.order.warehouseCategory = warehouse.category
  }

  translate(str: string) {
    return this.$t(str) as string
  }

  // Состав корзины для счётчиков. Брать до очистки: после оформления
  // customer.products уже пуст
  get trackedItems() {
    return customer.products.map((orderProduct: OrderProduct) => ({
      id: orderProduct.product.id || '',
      name: orderProduct.product.title,
      price: orderProduct.price,
      quantity: orderProduct.amount
    }))
  }

  get trackedTotal() {
    return customer.products.reduce(
      (sum: number, orderProduct: OrderProduct) =>
        sum + (orderProduct.price || 0) * orderProduct.amount, 0)
  }

  async submit() {
    this.attemptedToSumbit = true
    this.validate()
    if (this.valid) {  
      this.submitting = true
      try {
        var order = await createOrder(this.publicUrl, this.order)
      } catch (error) {
        this.$notify({
          group: 'br',
          text: this.translate('Ошибка добавления заказа. Пожалуйста, проверьте правильность заполнения и повторите попытку.'),
          type: 'error'
        })
        this.submitting = false
        return
      }
      // Покупку засчитает страница заказа, когда он подтверждён: при оплате
      // картой — после ответа кассы, а не при уходе на неё
      customer.setPendingPurchase({
        orderId: order.id as number,
        payload: { value: this.trackedTotal, transactionId: String(order.id), items: this.trackedItems }
      })
      customer.clearProducts()
      // Оплата картой: заказ ждёт подтверждения от кассы, поэтому вместо
      // «заказ добавлен» сразу уводим покупателя на оплату
      if (order.paymentLink) {
        window.location.href = order.paymentLink
        return
      }
      this.$notify({
        group: 'br',
        text: this.translate('Заказ успешно добавлен!'),
        type: 'success'
      })
      this.submitting = false
      // Ключ заказа — в адрес: без него страница заказа покажет только
      // минимум. shopPath — потому что на домене магазина префикса нет
      this.$router.push({ path: shopPath(`/orders/${order.id}`), query: { token: order.token } })
    } else {
      this.$notify({
        group: 'br',
        text: this.translate('Пожалуйста, заполните все обязательные поля.'),
        type: 'error'
      });
    }
  }

  setDefaultPaymentType() {
    this.order.paymentType = this.filteredPaymentTypes[0]
  }

  async mounted() {
    this.loading = true
    await customer.getRetailerPage(this.publicUrl)
    this.order.products = customer.products
    this.setDefaultPaymentType()
    this.loading = false
    if (customer.products.length) {
      track('begin_checkout', { value: this.trackedTotal, items: this.trackedItems })
    }
  }
}
